import { END_POINTS } from "../helpers";
import emptySplitApi from "../utils/rtk";

type ResponseData = {
  response_object: any;
  total_records: number;
  start: number;
  length: number;
};

type CommonResponseType = {
  status: number;
  message: string;
};

type UpdateSettingsParams = {
  body: {
    category: number;
    tax_flat: number;
    tax_percentage: number;
    platform_commission_flat: number;
    platform_commission_percentage: number;
    platform_commission_type: number;
  };
  id: string;
};

type SettingBody = {
  category: number;
  tax_flat: number;
  tax_percentage: number;
  platform_commission_flat: number;
  platform_commission_percentage: number;
  platform_commission_type: number;
};

type TimeBody = {
  orders_cancellation_time: number;
  orders_exchange_time: number;
};

type ServiceFeesBody = {
  response_time: string;
  avg_delivery_time: string;
  delivery_fees: string;
};

type ConversionBodyParams = {
  conversion_rate: number;
};

export const settingApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    addSettings: builder.mutation<
      CommonResponseType & { data: any },
      SettingBody
    >({
      query: (body) => ({
        url: `${END_POINTS.generelSettings}`,
        method: "POST",
        body,
      }),
    }),

    allSettings: builder.query<CommonResponseType & { data: any }, {}>({
      query: ({}) => ({
        url: `${END_POINTS.allSettings}`,
        method: "GET",
      }),
    }),

    getSettingsById: builder.query<
      CommonResponseType & { data: any },
      { id: string | undefined }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.settingsById}${id}/`,
        method: "GET",
      }),
    }),

    updateSettings: builder.mutation<CommonResponseType, UpdateSettingsParams>({
      query: ({ body, id }) => ({
        url: `${END_POINTS.updateSettings}${id}/`,
        method: "PUT",
        body,
      }),
    }),

    addTime: builder.mutation<CommonResponseType & { data: any }, TimeBody>({
      query: (body) => ({
        url: `${END_POINTS.addService}`,
        method: "POST",
        body,
      }),
    }),

    addService: builder.mutation<
      CommonResponseType & { data: any },
      ServiceFeesBody
    >({
      query: (body) => ({
        url: `${END_POINTS.addTime}`,
        method: "POST",
        body,
      }),
    }),

    getAllCms: builder.query<any & { data: any }, {}>({
      query: ({}) => ({
        url: `${END_POINTS.adminCms}`,
        method: "GET",
      }),
    }),

    getConversionRate: builder.query<any & { data: any }, {}>({
      query: ({}) => ({
        url: `${END_POINTS.getConversionRate}`,
        method: "GET",
      }),
    }),

    setConversionRate: builder.mutation<
      CommonResponseType & { data: any },
      ConversionBodyParams
    >({
      query: (body) => ({
        url: `${END_POINTS.setConversionRate}`,
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useAddSettingsMutation,
  useLazyAllSettingsQuery,
  useUpdateSettingsMutation,
  useLazyGetSettingsByIdQuery,
  useAddServiceMutation,
  useAddTimeMutation,
  useLazyGetAllCmsQuery,
  useLazyGetConversionRateQuery,
  useSetConversionRateMutation,
} = settingApi;
